
import {
  mdiMenu
} from '@mdi/js'
import { mapGetters } from 'vuex'
import LanguageSettingHeaderMenu from '@/components/account/data/LanguageSettingHeaderMenu.vue'

export default {
  name: 'Cm24NavigationDrawer',
  components: { LanguageSettingHeaderMenu },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      mdiMenu,
      drawer: null
    }
  },
  computed: {
    ...mapGetters({ isAdmin: 'isUserAdmin' }),

    imgSrc () {
      if (this.isAdmin) {
        return 'logo-440px-operator.png'
      } else {
        return 'logo-226.svg'
      }
    },

    showNavigationButton () {
      if (this.$vuetify.breakpoint.mobile && this.$route.name.startsWith('ad-edit-')) {
        return false
      }
      return true
    }
  },

  methods: {
    getLocalPath (item) {
      if (item.query) {
        return this.localePath({ name: item.link, query: item.query })
      } else {
        return this.localePath(item.link)
      }
    }
  }
}
